"use strict";

function getEndpoint() {
    if (typeof window !== "undefined" && window.graphqlEndpoint !== undefined) {
        return window.graphqlEndpoint
    }

    return process.env.GRAPHQL_ENDPOINT
}

export const graphqlEndpoint = getEndpoint()
